export enum HistoryType {
  Activity = 'activity',
  Skill = 'skill',
  Level = 'level',
  Opportunity = 'opportunity',
}
